import { CountryCode } from 'libphonenumber-js';
import { FormModel } from '../../../components/Form';
import { Validators } from '../../../utils/validators';

export const EditProfileForm = (
  strings: any,
  salutations: any[],
  languages: [],
  countries: [],
  states: [],
  cities: [],
  defaultCountry: CountryCode,
): FormModel[] => {
  return [
    {
      label: strings.user_profile_section_personal || 'Personal Information',
      value: '',
      type: 'section',
      placeholder: '',
      field: 'personal_section',
      validators: [],
      required: false,
      responsive: { xs: 12 },
    },
    {
      label: strings.users_salutation,
      placeholder: strings.users_salutation,
      value: '',
      size: 'medium',
      type: 'select',
      field: 'title',
      validators: [],
      required: false,
      isMulti: false,
      isClearable: true,
      responsive: { xs: 12, sm: 4 },
      options: salutations,
    },
    {
      label: strings.updateProfile_text_firstName,
      value: '',
      size: 'medium',
      autoFocus: true,
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'firstName',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: { xs: 12, sm: 4 },
      required: true,
    },
    {
      label: strings.updateProfile_text_lastName,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'lastName',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString }],
      responsive: { xs: 12, sm: 4 },
      required: true,
    },
    {
      label: strings.customerDetailsPhoneNumber,
      value: {},
      size: 'medium',
      type: 'phoneInput',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'phone',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateMobile }],
      responsive: { xs: 12, sm: 4 },
      required: true,
      defaultCountry: defaultCountry,
    },
    {
      label: strings.updateProfile_text_email,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'email',
      validators: [
        { check: Validators.validateMandatoryField },
        { check: Validators.validateEmail },
        { check: Validators.validateString },
      ],
      responsive: { xs: 12, sm: 4 },
      required: true,
      disabled: true,
      belowText: strings.user_profile_email_cannot_change || 'Cannot be changed',
    },
    {
      label: strings.updateProfile_text_language,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'language',
      validators: [],
      responsive: { xs: 12, sm: 4 },
      required: false,
      options: languages,
    },
    {
      label: strings.user_profile_section_work || 'Work & Company',
      value: '',
      type: 'section',
      placeholder: '',
      field: 'work_section',
      validators: [],
      required: false,
      responsive: { xs: 12 },
    },
    {
      label: strings.updateProfile_text_companyName,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'companyName',
      validators: [{ check: Validators.validateString }],
      responsive: { xs: 12, sm: 4 },
      required: false,
      disabled: false,
    },
    {
      label: strings.updateProfile_text_gst,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'gst',
      validators: [{ check: Validators.validateString, max: 20 }],
      responsive: { xs: 12, sm: 4 },
      required: false,
      disabled: false,
    },
    {
      label: strings.updateProfile_text_designation,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'designation',
      validators: [{ check: Validators.validateString, max: 50 }],
      responsive: { xs: 12, sm: 4 },
      required: false,
      disabled: false,
    },
    {
      label: strings.user_profile_section_address || 'Address',
      value: '',
      type: 'section',
      placeholder: '',
      field: 'address_section',
      validators: [],
      required: false,
      responsive: { xs: 12 },
    },
    {
      label: strings.updateProfile_text_country,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'country',
      validators: [],
      responsive: { xs: 12, sm: 4 },
      required: false,
      options: countries,
    },
    {
      label: strings.updateProfile_text_state,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'state',
      validators: [],
      responsive: { xs: 12, sm: 4 },
      required: false,
      options: states,
    },
    {
      label: strings.updateProfile_text_city,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'city',
      validators: [],
      responsive: { xs: 12, sm: 4 },
      required: false,
      options: cities,
    },
    {
      label: strings.updateProfile_text_address,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'address',
      validators: [{ check: Validators.validateString }],
      responsive: { xs: 12, sm: 8 },
      required: false,
    },
    {
      label: strings.updateProfile_text_pinCode,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'pinCode',
      validators: [{ check: Validators.validatePinCode }],
      responsive: { xs: 12, sm: 4 },
      required: false,
    },
  ];
};
